"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const MenuOptions_1 = __importDefault(require("../../../../../../reviews/components/MenuOptions"));
const mockData_1 = require("./mockData");
const stage_settings_types_1 = require("./stage-settings-types");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../../../../../reviews/helper");
const defaultData_1 = require("../../defaultData");
const StageSettings = (props) => {
    const { defaultDueDate, dueDate, onChangeDueDate, stageStatusStrategy = { label: 'Select status Calculation', value: '' }, onChangeStatusStrategy, validStageStatusStrategy, indexStage, statusStrategyOptions, stageDeadlineType, formikProps, isReadOnly = false, } = props;
    const onChangeFinalStatus = (option) => {
        if ((0, lodash_1.isFunction)(onChangeStatusStrategy)) {
            onChangeStatusStrategy(option);
        }
    };
    const { errors } = formikProps;
    const validationDeadline = () => {
        var _a, _b, _c;
        if (errors === null || errors === void 0 ? void 0 : errors.stages) {
            if ((_a = errors === null || errors === void 0 ? void 0 : errors.stages[indexStage]) === null || _a === void 0 ? void 0 : _a.deadline) {
                return (0, lodash_1.isString)((_b = errors === null || errors === void 0 ? void 0 : errors.stages[indexStage]) === null || _b === void 0 ? void 0 : _b.deadline);
            }
            return !!((_c = errors === null || errors === void 0 ? void 0 : errors.stages[indexStage]) === null || _c === void 0 ? void 0 : _c.deadline);
        }
        return false;
    };
    const deadlineType = mockData_1.DEADLINE.find((item) => item.value === stageDeadlineType) || mockData_1.DEADLINE[0];
    const [deadline, setDeadline] = (0, react_1.useState)(dueDate ? deadlineType : mockData_1.DEADLINE[0]);
    const [selectedDateTime, setSelectedDateTime] = (0, react_1.useState)(dueDate
        ? new Date((0, moment_1.default)(dueDate).tz(helper_1.USER_TIMEZONE).format())
        : null);
    const onChangeDateTime = (newDateTime) => {
        const newDateTimeState = selectedDateTime;
        if (Array.isArray(newDateTime)) {
            // handle when change
            newDateTimeState === null || newDateTimeState === void 0 ? void 0 : newDateTimeState.setHours(newDateTime[0].getHours());
            newDateTimeState === null || newDateTimeState === void 0 ? void 0 : newDateTimeState.setMinutes(newDateTime[0].getMinutes());
            newDateTimeState === null || newDateTimeState === void 0 ? void 0 : newDateTimeState.setSeconds(newDateTime[0].getSeconds());
        }
        else {
            // handle when change date
            newDateTimeState === null || newDateTimeState === void 0 ? void 0 : newDateTimeState.setFullYear(newDateTime === null || newDateTime === void 0 ? void 0 : newDateTime.getFullYear());
            newDateTimeState === null || newDateTimeState === void 0 ? void 0 : newDateTimeState.setMonth(newDateTime === null || newDateTime === void 0 ? void 0 : newDateTime.getMonth());
            newDateTimeState === null || newDateTimeState === void 0 ? void 0 : newDateTimeState.setDate(newDateTime === null || newDateTime === void 0 ? void 0 : newDateTime.getDate());
        }
        const updatedDateTime = newDateTimeState || newDateTime;
        setSelectedDateTime(updatedDateTime);
        onChangeDueDate(updatedDateTime, deadline.value);
    };
    const onChangeDeadline = (option) => {
        onChangeDueDate(selectedDateTime, option.value);
        if (option.type === stage_settings_types_1.DeadlineType.noDeadline) {
            setSelectedDateTime(null);
            onChangeDueDate(null, mockData_1.DEADLINE[0].value);
        }
        if (option.type === stage_settings_types_1.DeadlineType.specificDate) {
            const today = new Date();
            today.setMinutes(today.getMinutes() + 10);
            const newDate = defaultDueDate ? new Date(defaultDueDate) : today;
            setSelectedDateTime(newDate);
            onChangeDueDate(newDate, option.value);
        }
        if (option.type === stage_settings_types_1.DeadlineType.startDate) {
            const updateDate = new Date();
            updateDate.setMinutes(updateDate.getMinutes() + 10);
            setSelectedDateTime(updateDate);
            onChangeDueDate(updateDate, option.value);
        }
        if (option.type === stage_settings_types_1.DeadlineType.nBusinessDay) {
            const numberOfDay = Number(option.value.split('_')[0]);
            const updateDate = new Date();
            updateDate === null || updateDate === void 0 ? void 0 : updateDate.setDate(updateDate.getDate() + numberOfDay);
            setSelectedDateTime(updateDate);
            onChangeDueDate(updateDate, option.value);
        }
        setDeadline(option);
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__root'] },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__row'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__item'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__item--label'] },
                    react_1.default.createElement("label", null, "Decision Rule"),
                    react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                            className: 'overview-root__tooltip',
                            content: (react_1.default.createElement("span", { style: { whiteSpace: 'pre-line' } }, defaultData_1.decisionRuleTooltips)),
                            popperOptions: {
                                strategy: 'fixed',
                            },
                            placement: 'top',
                        } },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['row-label__icon'], 'fal fa-info-circle') }))),
                react_1.default.createElement(MenuOptions_1.default, { classes: {
                        root: styles_modules_less_1.default['stage-settings__menu'],
                        menu: {
                            menuCtn: styles_modules_less_1.default['stage-settings__menuCtn'],
                        },
                        select: styles_modules_less_1.default['stage-settings__select'],
                        menuListCustom: styles_modules_less_1.default['stage-settings___menuList'],
                    }, value: stageStatusStrategy, options: statusStrategyOptions, handleChange: onChangeFinalStatus, isInvalid: validStageStatusStrategy, name: `stage[${indexStage}].status_strategy_id`, variant: "v3", isDisabled: isReadOnly }))),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__row'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__item'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__item--label'] },
                    react_1.default.createElement("label", null, "Stage Deadline"),
                    react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                            className: 'overview-root__tooltip',
                            content: (react_1.default.createElement("span", { style: { whiteSpace: 'pre-line' } }, defaultData_1.stageDeadlineTooltip)),
                            popperOptions: {
                                strategy: 'fixed',
                            },
                            placement: 'top',
                        } },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['row-label__icon'], 'fal fa-info-circle') }))),
                react_1.default.createElement(MenuOptions_1.default, { classes: {
                        root: styles_modules_less_1.default['stage-settings__menu'],
                        menu: {
                            menuCtn: styles_modules_less_1.default['stage-settings__menuCtn'],
                        },
                        menuListCustom: styles_modules_less_1.default['stage-settings___menuList'],
                    }, value: deadline, handleChange: onChangeDeadline, options: mockData_1.DEADLINE, isInvalid: validationDeadline(), error: "Can not choose date in the past", variant: "v3", isDisabled: isReadOnly })),
            deadline.value === stage_settings_types_1.DeadlineType.specificDate && (react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-settings__item'], styles_modules_less_1.default['stage-settings__time-picker']) },
                react_1.default.createElement("label", null, "Date"),
                react_1.default.createElement(pulse_components_1.PulseDatePicker, { classes: {
                        root: styles_modules_less_1.default['date-picker__root'],
                    }, DatepickerProps: {
                        DatePickerInputProps: {
                            fullWidth: true,
                            disabled: isReadOnly,
                        },
                        variant: 'input',
                        TippyProps: {
                            appendTo: document.body,
                        },
                    }, isV3: true, onChange: (dates) => { var _a; return onChangeDateTime((_a = dates === null || dates === void 0 ? void 0 : dates.values) === null || _a === void 0 ? void 0 : _a.startDate); }, values: { startDate: selectedDateTime } }))),
            deadline.value !== stage_settings_types_1.DeadlineType.noDeadline && (react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['stage-settings__item'], styles_modules_less_1.default['stage-settings__time-picker']) },
                react_1.default.createElement("label", null, "Time"),
                react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-settings__item--time'] },
                    react_1.default.createElement(pulse_components_1.PulseTooltip, { contentTooltip: selectedDateTime === null || selectedDateTime === void 0 ? void 0 : selectedDateTime.toTimeString() },
                        react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-clock', styles_modules_less_1.default['time-picker__icon']) })),
                    react_1.default.createElement(pulse_components_1.PulseTimepicker, { classes: {
                            textField: styles_modules_less_1.default['time-picker__text-field'],
                        }, onChange: onChangeDateTime, disabled: isReadOnly, selectedTime: selectedDateTime, options: {
                            appendTo: document.body,
                            allowInput: false,
                            static: false,
                            position: 'below center',
                        } })))))));
};
exports.default = StageSettings;
